module.exports = __webpack_public_path__ + "static/img/px-logo.1bf6d62b.png";